import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Backdrop, Fade } from '@material-ui/core';
import Text from '../Typography/Text';
import fontFamily from '../../assets/css/fonts';
import color from '../../assets/css/colors';
import Button from '../Buttons/Button';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 550,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      backgroundColor: 'red',
      marginTop: '-4px !important',
    },
  },
}));

export default function NotificationModal({
  open,
  onClose,
  title,
  message,
  errorMessage,
}) {
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <div style={{ width: 500 }}>
          <div className={classes.modalHeader}>
            <div>
              <Text mt={4} variant="h2" color={color.warning.main} label={title} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div>{message}</div>
            {errorMessage && (
              <div style={{ marginTop: 10 }}>
                <b>Error:</b> {errorMessage}
              </div>
            )}
          </div>
          <div className={classes.modalFooter}>
            <Button
              style={{
                marginRight: 10,
              }}
              label="Close"
              color="secondary"
              onClick={onClose}
            />
            {/* <Button label="Send Report" onClick={() => {}} /> */}
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
